<template>
	<el-dialog
		:title="translations.labels.areYouSure"
		:visible.sync="show"
		:show-close="false"
		:close-on-press-escape="false"
		:close-on-click-modal="false"
		width="400px"
	>
		{{ message }}
		<div slot="footer" class="dialog-footer">
			<el-button
				@click="proceed()"
				:loading="processing"
				type="danger"
				plain
			>
				{{ label }}
			</el-button>
			<el-button
				@click="cancel()"
				plain
			>
				{{ translations.labels.cancel }}
			</el-button>
		</div>
	</el-dialog>
</template>

<script>
import { EventBus } from '@/services/event-bus'

export default {
    name: 'DeleteConfirmation',
	props: {
		cancelAction: String,
		confirmAction: String,
		show: Boolean,
		label: String,
		message: String,
		processing: Boolean
	},
	methods: {
		cancel () {
			EventBus.$emit(this.cancelAction)
		},
		proceed () {
			EventBus.$emit(this.confirmAction)
		}
	}
}
</script>
